export default "__VITE_ASSET__DK_t$nE3__"